import React from 'react'

export const ErrorMessage = ({ error, ...rest }: { error?: string }) => {
  if (!error || typeof error !== 'string') {
    return null
  }
  return (
    <p {...rest} className="text-xs text-red-500">
      {error}
    </p>
  )
}
